<template>
  <form class="select-payment">
    <fieldset class="select-payment-option">
      <div class="form-row">
        <div v-for="type in types" :key="type.id" class="form-column">
          <div class="checkinput">
            <input :value="type.id"
                   :id="type.id"
                   :checked="type.selected"
                   type="radio"
                   name="payment-options"
                   @change="onChangeType(type, $event.target.checked)">
            <label :for="type.id" class="equal-heights">
              {{ type.title }}
              <span class="payment-price">{{ $n(type.price.amount, 'currency') }}</span>
              <span class="payment-info">{{ type.info }}</span>
            </label>
          </div>
          <div v-if="type.isTermPaymentType && type.selected"
               class="term-payment-optin">
            <input
              id="term-agreement"
              :checked="termAgreement"
              type="checkbox" @change="onChangeTermAgreement($event.target.checked)">
            <label for="term-agreement">{{ $t('payment.term-agreement-title') }}</label>
            <p>
              <em>
                {{ $t('payment.term-agreement-info') }}
              </em>
            </p>
          </div>
        </div>
      </div>
    </fieldset>
  </form>
</template>

<script>

import authenticationMixin from '../mixins/authentication'

export default {
  name: 'PaymentTypeForm',
  mixins: [authenticationMixin],
  props: {
    isPaymentTypeSelected: {
      type: Boolean,
      required: true
    },
    isPaymentInTerms: {
      type: Boolean,
      required: true
    },
    termAgreement: {
      type: Boolean,
      required: true
    },
    price: {
      type: Object,
      required: true
    }
  },
  computed: {
    types: function () {
      let directPaymentType = {
        id: 'direct-payment-select',
        title: this.$t('payment.type-direct-title'),
        price: this.price,
        info: this.isStoreUser ? this.$t('payment.type-direct-info-store-user') : this.$t('payment.type-direct-info'),
        isTermPaymentType: false,
        selected: this.isPaymentTypeSelected && !this.isPaymentInTerms
      }
      let termPaymentType = {
        id: 'term-payment-select',
        title: this.$t('payment.type-term-title'),
        price: this.price,
        info: this.$t('payment.type-term-info'),
        isTermPaymentType: true,
        selected: this.isPaymentTypeSelected && this.isPaymentInTerms

      }
      return [directPaymentType, ...!this.isStoreUser ? [termPaymentType] : []]
    }
  },
  methods: {
    onChangeType: function (type, selected) {
      if (selected) {
        this.$emit('isPaymentInTermsChanged', type.isTermPaymentType)
      }
    },
    onChangeTermAgreement: function (checked) {
      this.$emit('termAgreementChanged', checked)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/PaymentType.vue